<ng-container *transloco="let t">
  <ng-container [formGroup]="editForm">
    <ng-container formGroupName="config">

      <div class="row" formArrayName="answers">
        <div class="col-12">
          <mat-label>{{t('answers-edit.answers')}}</mat-label>
          <ol>
            <li *ngFor="let answer of answers$ | async ">{{answer}} <mat-icon *ngIf="mode === 'edit'"
                (click)="removeAnswer(answer)"><i class="material-icons">clear</i></mat-icon>
            </li>
          </ol>
        </div>
      </div>
      <div class="row" *ngIf="mode === 'edit'">
        <div class="col-12">
          <mat-form-field class="w-100" appearance="fill">
            <input matInput formControlName="answers" type="text" #answerInput
              (keyup.enter)="addAnswer(answerInput.value); answerInput.value = ''" />
            <mat-label>{{t('answers-edit.addAnswer')}}</mat-label>
            <button matSuffix mat-button mat-icon-button (click)="addAnswer(answerInput.value); answerInput.value = ''"
              type="button">
              <mat-icon><i class="material-icons">add</i></mat-icon>
            </button>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
